import React from 'react';

export function EmptyCell() {
  return (
    <div
      style={{
        background: '#dedede',
        width: '200%',
        height: '100%',
        marginLeft: '-8px',
      }}
    >
      {' '}
    </div>
  );
}
